// src/pages/admin/ReviewList.tsx
import React, { useEffect, useState } from "react";
import { reviewService } from "../../services/reviewService";

interface Review {
  id: string;
  name: string;
  comment: string;
  approved: boolean;
}

const ReviewList: React.FC = () => {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    reviewService.getAll().then(setReviews);
  }, []);

  const handleApprove = async (id: string) => {
    await reviewService.approve(id);
    setReviews((prev) =>
      prev.map((r) => (r.id === id ? { ...r, approved: true } : r))
    );
  };

  return (
    <div className="admin-container">
      <h2 className="admin-header">User Reviews</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Comment</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review) => (
            <tr key={review.id}>
              <td>{review.name}</td>
              <td>{review.comment}</td>
              <td>{review.approved ? "Approved" : "Pending"}</td>
              <td>
                {!review.approved && (
                  <button
                    className="adminAddButton"
                    onClick={() => handleApprove(review.id)}
                  >
                    Approve
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewList;
